const addInfo = {
  title: 'FuelManagement',
  icon: 'fuel-management'
}
const fuelManagementRouter = {
  path: '/fuel-management',
  meta: {
    title: 'FuelManagement',
    icon: 'fuel-management',
    permission: ['fuel_management']
  },
  children: [
    {
      path: 'fuel-log',
      name: 'FuelLog',
      meta: { title: 'FuelLog' },
      children: [
        {
          path: 'overview',
          component: () => import('@/views/fuel-management/FuelLog/overview'),
          name: 'FuelManagementOverview',
          meta: { title: 'Overview', icon: 'subsubmenu', permission: ['fuel_overview_enable'] }
        },
        {
          path: 'fuel-consumption-management',
          component: () => import('@/views/fuel-management/FuelLog/fuel-consumption-management'),
          name: 'FuelConsumptionManagement',
          meta: { title: 'FuelConsumptionHistory', icon: 'subsubmenu', enableBack: true, backPage: 'FuelManagementOverview', permission: ['fuel_consumption_history_enable'] }
        },
        {
          path: 'refuel-management',
          component: () => import('@/views/fuel-management/FuelLog/refuel-management'),
          name: 'RefuelManagement',
          meta: { title: 'RefuelManagement', icon: 'subsubmenu', permission: ['refuel_management_enable'] }
        },
        {
          path: 'create-refuel-form/:id?',
          component: () => import('@/views/fuel-management/FuelLog/components/refuel-form'),
          name: 'RefuelForm',
          hidden: true,
          meta: { title: 'RefuelForm', icon: 'subsubmenu', activeMenu: '/fuel-log/refuel-management', enableBack: true, backPage: 'RefuelManagement', permission: ['refuel_management_create']  }
        },
        {
          path: 'update-refuel-form/:id?',
          component: () => import('@/views/fuel-management/FuelLog/components/refuel-form'),
          name: 'UpdateRefuelForm',
          hidden: true,
          meta: { title: 'RefuelForm', icon: 'subsubmenu', activeMenu: '/fuel-log/refuel-management', enableBack: true, backPage: 'RefuelManagement', permission: ['refuel_management_update']}
        },
        {
          path: 'refuel-import',
          component: () => import('@/views/fuel-management/FuelLog/components/refuel-import'),
          name: 'RefuelImport',
          hidden: true,
          meta: { title: 'RefuelImport', icon: 'subsubmenu', activeMenu: '/fuel-log/refuel-management', enableBack: true, backPage: 'RefuelManagement', permission: ['refuel_management_create']}
        }
      ]
    },
    {
      path: 'fuel-price-management',
      component: () => import('@/views/fuel-management/FuelPriceManagement/fuel-price-management'),
      name: 'FuelPriceManagement',
      meta: { title: 'FuelPriceManagement', parent: addInfo, permission: ['fuel_price_model_enable'] }
    },
    {
      path: 'fuel-spend',
      name: 'FuelSpend',
      meta: { title: 'FuelSpend', parent: addInfo, permission: ['fuel_spend_vehicle_enable', 'fuel_spend_driver_enable'] },
      children: [
        {
          path: 'vehicle',
          component: () => import('@/views/fuel-management/FuelSpend/vehicle'),
          name: 'FuelSpendVehicle',
          meta: { title: 'FuelSpendVehicle', parent: addInfo, permission: ['fuel_spend_vehicle_enable'] }
        },
        {
          path: 'vehicle-fuel-spend-detail',
          component: () => import('@/views/fuel-management/FuelSpend/vehicle-fuel-spend-detail'),
          name: 'FuelSpendVehicleDetail',
          hidden: true,
          meta: { title: 'FuelSpendVehicleDetail', parent: addInfo, enableBack: true, backPage: 'FuelSpendVehicle', permission: ['fuel_spend_vehicle_enable'] }
        },
        {
          path: 'driver',
          component: () => import('@/views/fuel-management/FuelSpend/driver'),
          name: 'FuelSpendDriver',
          meta: { title: 'FuelSpendDriver', parent: addInfo, permission: ['fuel_spend_driver_enable'] }
        },
        {
          path: 'driver-fuel-spend-detail',
          component: () => import('@/views/fuel-management/FuelSpend/driver-fuel-spend-detail'),
          name: 'FuelSpendDriverDetail',
          hidden: true,
          meta: { title: 'FuelSpendDriverDetail', parent: addInfo, enableBack: true, backPage: 'FuelSpendDriver', permission: ['fuel_spend_driver_enable'] }
        },
      ]
    },
  ]
}

export default fuelManagementRouter
